import { Injectable } from '@angular/core';
import { LiteratureDataService } from '@literature/services/literature-data.service';
import { ApiUrls, AppStateService } from '@services/app-state.service';
import { Observable } from 'rxjs';
import { IUserProfile } from '@services/profile.interface';
import {
  MailRequestBody,
  MailFormValues,
  MailResponseObject,
  MailResponseError,
} from '@types';

@Injectable({
  providedIn: 'root',
})
export class LiteratureYourCartMailConfirmOrderService {
  constructor(
    private literatureDataService: LiteratureDataService,
    private appStateService: AppStateService
  ) {}

  getApiUrl(): ApiUrls {
    return this.appStateService.getApiUrls();
  }

  getMailFormValue(): MailFormValues {
    return this.literatureDataService.getMailFormValue();
  }

  postMail(mailRequestBody: MailRequestBody): Observable<MailResponseObject> {
    return this.literatureDataService.mailDocument(mailRequestBody);
  }

  setPostMailResponse(response: MailResponseObject): void {
    this.literatureDataService.setPostMailResponse(response);
  }
  setPostMailError(response: MailResponseError): void {
    this.literatureDataService.setPostMailError(response);
  }
}
